import { Flex } from '@chakra-ui/react';
import { Logo } from '@/components/ui/Logo/Logo';
import { ForgotPasswordForm } from './components/ForgotPasswordForm/ForgotPasswordForm';

export const ForgotPasswordPage = () => {
  return (
    <Flex minH="100vh" bg="white" justify="center" align="center" p="5">
      <Flex w="full" maxW="400px" direction="column" align="center">
        <Logo />
        <ForgotPasswordForm />
      </Flex>
    </Flex>
  );
};
